<template>
  <div class="modal" v-if="showModal">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header px-0 m-auto pt-0">
          <span class="fs-5">{{ title }}</span>
        </div>
        <div v-html="content" class="modal-body" :class="addClass"></div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalView",
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    title: String,
    content: String,
    addClass: String,
  },
  methods: {
    closeModal() {
      // 부모 컴포넌트로 이벤트 발생을 요청합니다.
      this.$emit('close-modal');
    },
  },
}
</script>

<style scoped>
/* 모달 스타일링 */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.modal-scroll {
  height: 50vh;
  overflow-y: auto;
}
</style>